import messages from './configurators.en.json';
import {normalizeMessage, useTranslation} from './translation';

export function useConfiguratorTranslation() {
    const {english, t} = useTranslation();
    return {english, t: text => english ? messages[normalizeMessage(text)] || t(text) : text};
}

const letters = {'а':'a','б':'b','в':'v','г':'g','д':'d','е':'e','ё':'yo','ж':'zh','з':'z','и':'i','й':'y','к':'k','л':'l','м':'m','н':'n','о':'o','п':'p','р':'r','с':'s','т':'t','у':'u','ф':'f','х':'kh','ц':'ts','ч':'ch','ш':'sh','щ':'shch','ъ':'','ы':'y','ь':'','э':'e','ю':'yu','я':'ya'};
const cityNames = {'Москва':'Moscow','Санкт-Петербург':'Saint Petersburg','Екатеринбург':'Yekaterinburg','Нижний Новгород':'Nizhny Novgorod','Орёл':'Oryol'};
export function englishCityName(city) {
    return cityNames[city] || [...city].map(char => {
        const value = letters[char.toLowerCase()];
        if (value === undefined) return char;
        return char === char.toUpperCase() ? value.charAt(0).toUpperCase() + value.slice(1) : value;
    }).join('');
}

export function cityOptionsForLanguage(cities, query, english) {
    const search = query.toLowerCase();
    return cities.filter(city => city.toLowerCase().includes(search) || (english && englishCityName(city).toLowerCase().includes(search)))
        .map(city => ({value: english ? englishCityName(city) : city}));
}
